import { createContext, useContext } from 'react';
import type { TokenBundle } from './auth0';

export type AuthState = {
  ready: boolean;
  tokens: TokenBundle | null;
  email: string | null;
};

export type AuthActions = {
  signIn(opts?: { screenHint?: 'signup' }): Promise<void>;
  signOut(): void;
  getValidAccessToken(): Promise<string | null>;
};

export const AuthContext = createContext<(AuthState & AuthActions) | null>(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}